import styled from 'styled-components';
import { COLOR } from '@src/styles/color';

export const StyledButtonLabel = styled('div')`
  width: 100%;
  .input-error {
    color: ${COLOR.functionalRed.default};
    font-size: 14px;
    font-weight: 400;
    line-height: 20px;
    letter-spacing: -0.4px;
  }
`;
